import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/dots.gif")